import React, {useEffect} from "react";
import isMobile from "ismobilejs";
import ScrollReveal from "scrollreveal";

export default function Chart2() {

    useEffect(() => {
        const chart = document.querySelector('#Chart2 svg');

        window.addEventListener('scroll', () => {
            const chartRect = chart.getBoundingClientRect();

            if (chartRect.bottom <= window.innerHeight * 1.2) {
                chart.classList.add('animate');
            }
        })
    }, []);

    const svg = `
<svg width="527px" height="550px" viewBox="0 0 527 550" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g  transform="translate(-16.000000, 1.000000)">
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="465.86" y="530">Logiciels </tspan>
                <tspan x="449.228" y="546">pour  mobiles</tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="350.956" y="530">PC gamer, </tspan>
                <tspan x="352.924" y="546">hardware </tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="240.076" y="530">Jeux video </tspan>
                <tspan x="267.236" y="546">PC</tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="116.416" y="530">Publicité dans </tspan>
                <tspan x="118.368" y="546">les jeux vidéo </tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="18.872" y="530">Consoles,</tspan>
                <tspan x="18.424" y="546">hardware </tspan>
            </text>
            <rect  fill="#74B743" x="16" y="401" width="82" height="83"></rect>
            <rect  fill="#74B743" x="125.75" y="376" width="82" height="108"></rect>
            <rect  fill="#74B743" x="235.5" y="259" width="82" height="225"></rect>
            <rect  fill="#74B743" x="345.25" y="255" width="82" height="229"></rect>
            <rect  fill="#74B743" x="455" y="24" width="82" height="460"></rect>
            <text  font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="253.19" y="250">40M$</tspan>
            </text>
            <text  font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="142.23" y="367">20,8$</tspan>
            </text>
            <text  font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="25.1" y="392">15,3M$</tspan>
            </text>
            <text  font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="354.1" y="246">41,4M$</tspan>
            </text>
            <text  font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="463.6" y="15">83,7M$</tspan>
            </text>
        </g>
    </g>
</svg>`;

    return (
        <div id={'Chart2'} dangerouslySetInnerHTML={{__html: svg}}/>
    )
}
